// Plurales en español para los textos con números (F3a2): "1 inspección", "2 inspecciones"; nunca "inspección(es)",
// "inspeccións" ni "1 vez/veces". Las siglas (EPP, SST, PDF) no llevan plural.

/** "1 inspección" / "3 inspecciones". Con la forma plural explícita: es lo más seguro para frases. */
export function plural(n: number, singular: string, plural: string): string {
  return `${n} ${n === 1 ? singular : plural}`;
}

/** Solo la palabra, sin el número: palabra(2, 'firmada', 'firmadas') → "firmadas". */
export const palabra = (n: number, singular: string, plural: string): string => (n === 1 ? singular : plural);

const SIN_TILDE: Record<string, string> = { á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u' };

/**
 * Plural de UNA palabra con las reglas regulares: vocal sin tilde → +s (hallazgo → hallazgos); -z → -ces (vez → veces);
 * aguda en -ión/-ón/-én/-ín/-ás… → pierde la tilde y +es (inspección → inspecciones); otra consonante → +es
 * (programación → programaciones, sector → sectores). Las siglas en mayúsculas quedan igual (EPP). Para frases o
 * irregulares, usar plural() con las dos formas.
 */
export function pluralizar(p: string): string {
  if (!p) return p;
  if (/^[A-ZÁÉÍÓÚÑ0-9]{2,}$/.test(p)) return p;                 // sigla: EPP, SST, PDF
  if (/[aeiou]$/i.test(p)) return `${p}s`;
  if (/[áéó]$/i.test(p)) return `${p}s`;                         // sofá → sofás, café → cafés
  if (/z$/i.test(p)) return `${p.slice(0, -1)}ces`;
  if (/s$|x$/i.test(p) && !/[áéíóú]s$/i.test(p)) return p;        // crisis, tórax: invariables
  const m = p.match(/([áéíóú])([nsl])$/i);
  if (m) return `${p.slice(0, -2)}${SIN_TILDE[m[1].toLowerCase()] ?? m[1]}${m[2]}es`;
  return `${p}es`;
}

/** "1 vez" / "3 veces". */
export const veces = (n: number): string => plural(n, 'vez', 'veces');
